// Invoice templates. Each is a set of layout switches read by both the
// on-screen preview (InvoicePreview) and the PDF renderer (pdf.js).
//
// header:  classic | banner | minimal | split | centered
// head:    fill (accent bg) | tint (light accent bg) | dark (slate bg) | line (underline only)
// totals:  boxed | band | plain
// font:    helvetica | times (PDF); preview maps to sans / serif

export const TEMPLATES = {
  classic: {
    label: "Classic",
    desc: "Bold letterhead, large clear type – your main invoice",
    header: "classic",
    head: "fill",
    stripe: false,
    grid: true,
    totals: "boxed",
    font: "helvetica",
    density: 1,
    bold: true,
  },
  modern: {
    label: "Modern",
    desc: "Colour banner header, striped rows",
    header: "banner",
    head: "tint",
    stripe: true,
    grid: false,
    totals: "band",
    font: "helvetica",
    density: 1,
  },
  minimal: {
    label: "Minimal",
    desc: "Clean black & white, lots of white space",
    header: "minimal",
    head: "line",
    stripe: false,
    grid: false,
    totals: "plain",
    font: "helvetica",
    density: 1,
  },
  corporate: {
    label: "Corporate",
    desc: "Boxed panels, dark table header",
    header: "split",
    head: "dark",
    stripe: true,
    grid: true,
    totals: "boxed",
    font: "helvetica",
    density: 1,
  },
  elegant: {
    label: "Elegant",
    desc: "Serif type, centred letterhead",
    header: "centered",
    head: "line",
    stripe: false,
    grid: false,
    totals: "plain",
    font: "times",
    density: 1,
  },
  compact: {
    label: "Compact",
    desc: "Dense rows – best for long monthly invoices",
    header: "classic",
    head: "fill",
    stripe: true,
    grid: true,
    totals: "boxed",
    font: "helvetica",
    density: 0.72,
  },
};

export const templateOptions = Object.entries(TEMPLATES).map(([value, t]) => ({ value, label: t.label }));

export const getTemplate = (key) => TEMPLATES[key] || TEMPLATES.classic;

// Mix a hex colour with white; amount 0..1 (1 = white).
export function tint(hex, amount) {
  const h = (hex || "#C62828").replace("#", "");
  const n = parseInt(h.length === 3 ? h.split("").map((c) => c + c).join("") : h, 16);
  const rgb = [(n >> 16) & 255, (n >> 8) & 255, n & 255].map((c) => Math.round(c + (255 - c) * amount));
  return "#" + rgb.map((c) => c.toString(16).padStart(2, "0")).join("");
}

export const hexToRgb = (hex) => {
  const h = (hex || "#C62828").replace("#", "");
  const n = parseInt(h.length === 3 ? h.split("").map((c) => c + c).join("") : h, 16);
  return [(n >> 16) & 255, (n >> 8) & 255, n & 255];
};
